import moment from "moment";
import { useEffect, useState } from "react";
import { getWeekColumnData } from "../../utils/annual-planner-helpers";
import submit from "submit-form";

// Same offset the periodization loader uses for its default `from`
const MONTHS_BEFORE_TODAY = 3;

const getDefaultWindowStart = () =>
  moment.utc().subtract(MONTHS_BEFORE_TODAY, "months").startOf("month");

export const useDateSelector = ({ from, startingCalendarDay, statsFrom }) => {
  const [dateFromState, setDateFromState] = useState(() =>
    moment(from).startOf("month")
  );

  const goToPreviousMonth = () =>
    setDateFromState((current) => moment(current).subtract(1, "month"));
  const goToNextMonth = () =>
    setDateFromState((current) => moment(current).add(1, "month"));
  const resetWindow = () => setDateFromState(getDefaultWindowStart());

  // This useEffect triggers the submit for getting more stats from the athlete
  // Happening when loading months without the athlete stats loaded
  useEffect(() => {
    // If the new date selected in the state is minor than the one getting from the params
    // this means that we have to fetch new data
    if (
      moment(dateFromState).format("YYYYMMDD") <
      moment(statsFrom, "YYYYMMDD").format("YYYYMMDD")
    ) {
      const rearrangedStatsFrom = getWeekColumnData(
        moment(statsFrom, "YYYYMMDD").subtract(1, "year"),
        startingCalendarDay,
        0
      );

      submit("/actions/refresh", {
        method: "GET",
        body: {
          statsFrom: moment(rearrangedStatsFrom, "YYYYMMDD").format("YYYYMMDD"),
          prevFrom: moment(statsFrom, "YYYYMMDD")
            .subtract(1, "day")
            .format("YYYYMMDD"),
        },
      });
    }
  }, [dateFromState]);

  return {
    dateFromState,
    goToPreviousMonth,
    goToNextMonth,
    resetWindow,
  };
};
